import React, { useEffect, useRef, useState } from 'react';
import SEO from '../../components/SEO';
import { seoData } from '../../utils/seoData';

const ContactOverviewPage = () => {
  const observerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    observerRef.current = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.animation = 'fadeInUp 0.8s ease-out forwards';
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    animatedElements.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(30px)';
      observerRef.current.observe(el);
    });

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  const contactInfo = [
    {
      title: "Head Office",
      icon: "fas fa-building",
      address: "B B Industry Complex",
      location: "Sudpara, Bolangir-767001, Odisha, India",
      phone: "+91 94370 31796",
      email: "roshanprasad.sbmi@gmail.com",
      hours: "Mon - Sat: 9:00 AM - 6:00 PM"
    },
    {
      title: "Manufacturing Unit",
      icon: "fas fa-industry",
      address: "Plot No. 10, 11, H17/2, Industrial Growth Centre Phase-I",
      location: "Madhiapali, Bolangir-767065, Odisha, India",
      phone: "+91 94373 68264",
      email: "alok.agrawal11@gmail.com",
      hours: "24/7 Operations"
    },
    {
      title: "Sales & Marketing",
      icon: "fas fa-handshake",
      address: "Commercial Complex",
      location: "Sudpara, Bolangir-767001, Odisha, India",
      phone: "+91 78736 48033",
      email: "avinashagr91@gmail.com", 
      hours: "Mon - Fri: 8:30 AM - 6:30 PM"
    }
  ];

  const departments = [
    {
      name: "Head Office",
      head: "Roshan Prasad",
      phone: "+91 94370 31796",
      email: "roshanprasad.sbmi@gmail.com",
      icon: "fas fa-building"
    },
    {
      name: "Manufacturing",
      head: "Alok Agrawal",
      phone: "+91 94373 68264",
      email: "alok.agrawal11@gmail.com",
      icon: "fas fa-industry"
    },
    {
      name: "Sales & Marketing",
      head: "Avinash Agrawal",
      phone: "+91 78736 48033",
      email: "avinashagr91@gmail.com",
      icon: "fas fa-handshake"
    },
    {
      name: "Recruitment",
      head: "Alok Agrawal",
      phone: "+91 94373 68264",
      email: "alok.agrawal.11@bbindustry.in",
      icon: "fas fa-cogs"
    }
  ];

  return (
    <div className="contact-overview-page">
      <SEO 
        title={seoData.contactOverview.title}
        description={seoData.contactOverview.description}
        keywords={seoData.contactOverview.keywords}
        canonical={seoData.contactOverview.canonical}
        ogImage={seoData.contactOverview.ogImage}
      />
      <style jsx>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .contact-overview-page {
          font-family: 'Inter', 'Poppins', sans-serif;
          line-height: 1.6;
          color: #1A202C;
          overflow-x: hidden;
        }

        /* Hero Section */
        .hero {
          background: linear-gradient(135deg, #5A1FB3 0%, #1E2329 100%);
          padding: 120px 0 80px;
          position: relative;
          overflow: hidden;
        }

        .hero::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" fill="%23ffffff" opacity="0.05"><polygon points="0,0 1000,0 1000,100 0,80"/></svg>');
          background-size: cover;
        }

        .hero-content {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 2rem;
          text-align: center;
          position: relative;
          z-index: 2;
        }

        .hero h1 {
          font-size: 3.5rem;
          font-weight: 800;
          color: white;
          margin-bottom: 1.5rem;
          line-height: 1.2;
        }

        .hero-subtitle {
          font-size: 1.3rem;
          color: rgba(255, 255, 255, 0.9);
          max-width: 800px;
          margin: 0 auto 2rem;
          font-weight: 400;
        }

        .hero-icon {
          width: 80px;
          height: 80px;
          background: #7B3FE4;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 2rem;
          box-shadow: 0 10px 30px rgba(123, 63, 228, 0.3);
        }

        .hero-icon i {
          font-size: 2rem;
          color: white;
        }

        /* Container */
        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 2rem;
        }

        .section-header {
          text-align: center;
          margin-bottom: 4rem;
        }

        .section-header h2 {
          font-size: 2.8rem;
          font-weight: 700;
          background: linear-gradient(135deg, #7B3FE4 0%, #5A1FB3 100%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin-bottom: 1rem;
        }

        .section-header p {
          font-size: 1.2rem;
          color: #4A5260;
          max-width: 600px;
          margin: 0 auto;
        }

        /* Contact Info Section */
        .contact-info-section {
          padding: 100px 0;
          background: #F5F7FA;
        }

        .contact-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
          gap: 2.5rem;
        }

        .contact-card {
          background: white;
          padding: 3rem;
          border-radius: 20px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
          transition: all 0.5s ease;
          position: relative;
          overflow: hidden;
        }

        .contact-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 5px;
          background: linear-gradient(90deg, #7B3FE4, #5A1FB3);
        }

        .contact-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 30px 80px rgba(0, 0, 0, 0.12);
        }

        .contact-header {
          display: flex;
          align-items: center;
          margin-bottom: 2rem;
        }

        .contact-icon {
          width: 70px;
          height: 70px;
          background: linear-gradient(135deg, #7B3FE4, #5A1FB3);
          border-radius: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 1.5rem;
          transition: all 0.3s ease;
        }

        .contact-card:hover .contact-icon {
          transform: scale(1.1) rotate(5deg);
        }

        .contact-icon i {
          font-size: 2rem;
          color: white;
        }

        .contact-card h3 {
          font-size: 1.8rem;
          font-weight: 700;
          color: #333;
          margin-bottom: 0.5rem;
        }

        .contact-details {
          space-y: 1rem;
        }

        .contact-item {
          display: flex;
          align-items: center;
          margin-bottom: 1rem;
          padding: 0.75rem;
          background: #F5F7FA;
          border-radius: 10px;
          transition: all 0.3s ease;
        }

        .contact-item:hover {
          background: rgba(123, 63, 228, 0.1);
          transform: translateX(5px);
        }

        .contact-item i {
          font-size: 1rem;
          color: #7B3FE4;
          margin-right: 0.75rem;
          width: 20px;
        }

        .contact-item span {
          color: #4A5260;
          font-weight: 500;
        }

        .contact-item a {
          color: #4A5260;
          text-decoration: none;
          transition: color 0.3s ease;
          word-break: break-word;
          overflow-wrap: break-word;
          hyphens: auto;
        }

        .contact-item a:hover {
          color: #7B3FE4;
        }

        /* Departments Section */
        .departments-section {
          padding: 100px 0;
          background: white;
        }

        .departments-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 2rem;
        }

        .department-card {
          background: #F5F7FA;
          padding: 2.5rem;
          border-radius: 15px;
          text-align: center;
          transition: all 0.4s ease;
          border: 2px solid transparent;
        }

        .department-card:hover {
          border-color: #7B3FE4;
          transform: translateY(-8px);
          box-shadow: 0 20px 50px rgba(123, 63, 228, 0.15);
        }

        .dept-icon {
          width: 70px;
          height: 70px;
          background: linear-gradient(135deg, #7B3FE4, #5A1FB3);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
          transition: all 0.3s ease;
        }

        .department-card:hover .dept-icon {
          transform: scale(1.1);
        }

        .dept-icon i {
          font-size: 1.8rem;
          color: white;
        }

        .department-card h4 {
          font-size: 1.3rem;
          font-weight: 600;
          color: #333;
          margin-bottom: 1rem;
        }

        .dept-head {
          font-weight: 600;
          color: #7B3FE4;
          margin-bottom: 0.5rem;
        }

        .dept-contact {
          color: #4A5260;
          font-size: 0.9rem;
          margin-bottom: 0.25rem;
          word-break: break-word;
          overflow-wrap: break-word;
          hyphens: auto;
        }

        /* Facility Tour Section */
        .facility-tour-section {
          padding: 100px 0;
          background: linear-gradient(135deg, #6d7580 0%, #505A66 100%);
          color: white;
        }

        .tour-images {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
          gap: 2rem;
        }

        .tour-image-container {
          position: relative;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          transition: all 0.4s ease;
        }

        .tour-image-container:hover {
          transform: translateY(-10px);
          box-shadow: 0 30px 80px rgba(0, 0, 0, 0.4);
        }

        .tour-image {
          width: 100%;
          height: 280px;
          object-fit: cover;
        }

        .tour-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
          color: white;
          padding: 2rem;
          transform: translateY(100%);
          transition: transform 0.4s ease;
        }

        .tour-image-container:hover .tour-overlay {
          transform: translateY(0);
        }

        .tour-overlay h4 {
          font-size: 1.5rem;
          margin-bottom: 0.5rem;
          font-weight: 600;
        }

        .tour-overlay p {
          font-size: 1rem;
          opacity: 0.9;
        }

        /* Map Section */
        .map-section {
          padding: 100px 0;
          background: #F5F7FA;
        }

        .map-container {
          background: white;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
          height: 400px;
          position: relative;
        }

        .map-overlay {
          position: absolute;
          bottom: 20px;
          left: 20px;
          background: rgba(255, 255, 255, 0.95);
          padding: 1.5rem;
          border-radius: 12px;
          backdrop-filter: blur(10px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
          max-width: 300px;
        }

        .map-info-card h4 {
          font-size: 1.2rem;
          font-weight: 600;
          color: #1A202C;
          margin-bottom: 0.5rem;
        }

        .map-info-card p {
          font-size: 0.9rem;
          color: #4A5260;
          margin-bottom: 0.25rem;
          line-height: 1.4;
        }

        .map-placeholder {
          text-align: center;
          color: #4A5260;
        }

        .map-placeholder i {
          font-size: 4rem;
          color: #7B3FE4;
          margin-bottom: 1rem;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .hero h1 {
            font-size: 2.5rem;
          }

          .hero-subtitle {
            font-size: 1.1rem;
          }

          .section-header h2 {
            font-size: 2.2rem;
          }

          .container {
            padding: 0 1rem;
          }

          .contact-grid {
            grid-template-columns: 1fr;
          }

          .departments-grid {
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          }

          .tour-images {
            grid-template-columns: 1fr;
          }

          .contact-card {
            padding: 2rem;
          }
        }

        /* Animations */
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fadeInUp 0.8s ease-out;
        }
      `}</style>

      {/* Add Font Awesome and Google Fonts */}
      <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" rel="stylesheet" />
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap" rel="stylesheet" />

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-icon animate-fade-in">
            <i className="fas fa-phone"></i>
          </div>
          <h1 className="animate-fade-in">Contact B B Industry</h1>
          <p className="hero-subtitle animate-fade-in">
            Connect with our team for aluminum solutions, manufacturing inquiries, and partnership opportunities
          </p>
        </div>
      </section>

      {/* Contact Information Section */}
      <section className="contact-info-section">
        <div className="container">
          <div className="section-header">
            <h2>Get In Touch</h2>
            <p>Multiple ways to connect with our team across different departments and locations</p>
          </div>
          
          <div className="contact-grid">
            {contactInfo.map((contact, index) => (
              <div key={index} className="contact-card animate-on-scroll">
                <div className="contact-header">
                  <div className="contact-icon">
                    <i className={contact.icon}></i>
                  </div>
                  <h3>{contact.title}</h3>
                </div>
                
                <div className="contact-details">
                  <div className="contact-item">
                    <i className="fas fa-map-marker-alt"></i>
                    <span>{contact.address}</span>
                  </div>
                  <div className="contact-item">
                    <i className="fas fa-location-dot"></i>
                    <span>{contact.location}</span>
                  </div>
                  <div className="contact-item">
                    <i className="fas fa-phone"></i>
                    <a href={`tel:${contact.phone}`}>{contact.phone}</a>
                  </div>
                  <div className="contact-item">
                    <i className="fas fa-envelope"></i>
                    <a href={`mailto:${contact.email}`}>{contact.email}</a>
                  </div>
                  <div className="contact-item">
                    <i className="fas fa-clock"></i>
                    <span>{contact.hours}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Departments Section */}
      <section className="departments-section">
        <div className="container">
          <div className="section-header">
            <h2>Department Contacts</h2>
            <p>Direct access to our specialized departments for specific inquiries and support</p>
          </div>
          
          <div className="departments-grid">
            {departments.map((dept, index) => (
              <div key={index} className="department-card animate-on-scroll">
                <div className="dept-icon">
                  <i className={dept.icon}></i>
                </div>
                <h4>{dept.name}</h4>
                <div className="dept-head">{dept.head}</div>
                <div className="dept-contact">{dept.phone}</div>
                <div className="dept-contact">
                  <a href={`mailto:${dept.email}`}>{dept.email}</a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Facility Tour Section */}


      {/* Map Section */}
      <section className="map-section">
        <div className="container">
          <div className="section-header">
            <h2>Find Us</h2>
            <p>Located in the heart of Balangir, Odisha - easily accessible for visits and meetings</p>
          </div>
          
          <div className="map-container" ref={mapRef}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3731.04967531873!2d83.49450877524896!3d20.748780580831397!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjDCsDQ0JzU1LjYiTiA4M8KwMjknNDkuNSJF!5e0!3m2!1sen!2sin!4v1759485166386!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{border: 0, borderRadius: '20px'}}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="B B Industry Manufacturing Unit Location"
            ></iframe>
            <div className="map-overlay">
              <div className="map-info-card">
                <h4>Manufacturing Unit</h4>
                <p>Plot No. 10, 11, H17/2, Industrial Growth Centre Phase-I</p>
                <p>Madhiapali, Bolangir-767065, Odisha</p>
                <p><strong>Contact:</strong> +91 94373 68264</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactOverviewPage;
